import axios from 'axios';
import { useQueryClient, useQuery } from '@tanstack/react-query';
import { fetchDefault, fetchFormAuth, setError } from 'src/fetch/common';
import { familyInfoDataFn } from 'src/fetch/stepA';
import { homeTaxInitData, homeTaxData } from 'src/static/sample/stepC';
import { dataSet, creditCardDataSet } from './dataSet';
import _ from 'lodash';
import { error } from 'console';
const stateTimeStr = process.env.REACT_APP_REACTQUERY_STALETIME || '0';
const STALETIME = Number(stateTimeStr);

// SELECT(LIST) 카드내역
export const creditcardInfoDataFn = async (
  errorModalState: any,
  param: any,
  initDataStore: any,
  queryClient: any,
  familyInfoDataState?: any,
  familyData?: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/creditcard/lst';
  const fetchKey = 'CREDITCARD_INFO';
  if (!familyData) {
    familyData = await familyInfoDataFn(errorModalState, param, familyInfoDataState, queryClient);
  }
  const familyDataSet = _.cloneDeep(familyData);

  try {
    const data = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    console.log('[CREDITCARD_INFO]:', paramSet, data);
    const infoData: any = data;
    const { resError, resData } = creditCardDataSet(infoData, familyDataSet, null);

    if (resError.type === 'error') {
      errorModalState({ data: resError, active: '_active' });
    } else {
      initDataStore({ data: resData });
      return resData;
    }
  } catch (e) {
    console.log('error:', e);
  }
};

// INSERT 카드내역
export const fetchInsertCardData = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/creditcard/ist';
  const fetchKey = 'CREDITCARD_INSERT';

  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });

    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};
// UPDATE 카드내역
export const fetchUpdateCardData = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/creditcard/upd';
  const fetchKey = 'CREDITCARD_UPDATE';

  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });

    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};
// DELETE 카드내역
export const fetchDeleteCardData = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/creditcard/del';
  const fetchKey = 'CREDITCARD_DELETE';

  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey, paramSet],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });
    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};
